<div class="marketing-page">
    <div class="topline">
        <div>
            <h2>Marketing Campaigns</h2>
            <div class="subtitle">Campaign setup, audience groups, and delivery history.</div>
        </div>
    </div>

    <nav mat-tab-nav-bar [tabPanel]="tabPanel" class="marketing-tabs">
        <a
            mat-tab-link
            *ngFor="let tab of tabs"
            (click)="gotoTab(tab)"
            [active]="tab.link == activeTab.link"
        >
            {{tab.title}}
        </a>
    </nav>

    <mat-tab-nav-panel #tabPanel>
        <app-marketing-campaigns-list *ngIf="activeTab.id === 'list'"></app-marketing-campaigns-list>
        <app-marketing-campaigns-sequences *ngIf="activeTab.id === 'sequences'"></app-marketing-campaigns-sequences>
        <app-marketing-campaigns-groups *ngIf="activeTab.id === 'groups'"></app-marketing-campaigns-groups>
        <app-marketing-campaigns-history *ngIf="activeTab.id === 'history'"></app-marketing-campaigns-history>
    </mat-tab-nav-panel>
</div>
